module.exports = __webpack_public_path__ + "img/khmelnitsk.12fb3b66.png";